// @ts-nocheck
import { AbstractRequestMessage } from "./AbstractRequestMessage";

export class RequestMessage extends AbstractRequestMessage {
  constructor() {
    super();
  }
}
